import { render, staticRenderFns } from "./TablesManage.vue?vue&type=template&id=2b681ff3&scoped=true&"
import script from "./TablesManage.vue?vue&type=script&lang=js&"
export * from "./TablesManage.vue?vue&type=script&lang=js&"
import style0 from "./TablesManage.vue?vue&type=style&index=0&id=2b681ff3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b681ff3",
  null
  
)

export default component.exports